var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsbabyboy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.68 22.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    strokeWidth: 0,
    d: "M22.68,22.68H0V0h22.68v22.68ZM.96,21.72h20.76V.96H.96v20.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    strokeWidth: 0,
    d: "M19.96,19.96H2.72V2.71h17.25v17.25ZM3.67,19.01h15.33V3.67H3.67v15.33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsbabyboy);
export default __webpack_public_path__ + "static/media/KIDSBABYBOY.0a3a3eeff73689ea6aa5b3a019685970.svg";
export { ForwardRef as ReactComponent };